import { Component, Injector, Input } from '@angular/core';
import { MakeProvider } from '../AbstractValueAccessor';
import { TranslateService } from '@ngx-translate/core';
import { BsNgInputBaseComponent } from '../BsNgInputTextBaseComponent';
import { NgControl } from '@angular/forms';
import { InputViewModeEnum } from '../bs-ng-dropdown/InputViewModeEnum';

@Component({
  selector: 'bs-ng-text',
  templateUrl: './bs-ng-text.component.html',
  providers: [MakeProvider(BsNgTextComponent)],
})
export class BsNgTextComponent extends BsNgInputBaseComponent {
  @Input() emailErrorMessage = '';

  @Input() maxLength: string;

  ///using the ngx-mask properties https://www.npmjs.com/package/ngx-mask/v/13.1.15
  @Input() mask: string;
  @Input() prefix: string = '';
  @Input() dropSpecialCharacters: boolean | string[];

  @Input()
  trimWhitespace: boolean = false;

  @Input()
  viewMode: InputViewModeEnum = InputViewModeEnum.Input;

  @Input()
  displayDefaultValue: any = null;

  override onBlur() {
    if (this.trimWhitespace && this.value?.trim) {
      this.value = this.value.trim();
    }

    super.onBlur();
  }

  get _maxLength(): number {
    return Number(this.maxLength);
  }

  public get isDisplay(): boolean {
    return this.viewMode == InputViewModeEnum.Display;
  }

  constructor(translate: TranslateService, injector: Injector) {
    super(translate, injector);
  }

  ngOnInit() {
    if (this.key !== '') {
      this.getTranslations();
    }
    this.ngControl = this.inj.get(NgControl);
  }

  protected assignTranslations(trs: any) {
    super.assignTranslations(trs);
    this.emailErrorMessage = trs.emailErrorMessage;
  }

  get hasErrors(): boolean {
    if (this.ngControl.control.touched) {
      return this.ngControl.errors && true;
    }

    return false;
  }

  public get isShowErrors(): boolean {
    return (
      this.ngControl.touched &&
      !this.ngControl.valid &&
      !this.ngControl.disabled
    );
  }

  get touched() {
    return this.ngControl.control.touched;
  }
}
